/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Image_SlotInputs */

const cs_builder_block_image_slot = /** @type {(inputs: Builder_Block_Image_SlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediální slot`)
};

const en_builder_block_image_slot = /** @type {(inputs: Builder_Block_Image_SlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image slot`)
};

/**
* | output |
* | --- |
* | "Image slot" |
*
* @param {Builder_Block_Image_SlotInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_image_slot = /** @type {((inputs?: Builder_Block_Image_SlotInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Image_SlotInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_image_slot(inputs)
	return cs_builder_block_image_slot(inputs)
});